/**
 * An asimov fieldset component with child elements.
 */

import PropTypes from 'prop-types';

import React from 'react';
import classNames from 'classnames';

class FieldSet extends React.Component {
    renderHeader() {
        if (this.props.title) {
            return (
                <div className="fieldset__header">
                    <h2 className="fieldset__title">{this.props.title}</h2>
                    <p className="fieldset__description">{this.props.description}</p>
                </div>
            );
        }
    }

    renderChildren() {
        return <div className="fieldset__children">{this.props.children}</div>;
    }

    render() {
        let classes = classNames('fieldset', {
            'fieldset--two-column': this.props.twoColumn,
            'fieldset--interjection': this.props.interjection,
        });

        return (
            <fieldset className={classes}>
                {this.renderHeader()}
                {this.renderChildren()}
                {this.props.interjection}
            </fieldset>
        );
    }
}

FieldSet.propTypes = {
    twoColumn: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    interjection: PropTypes.element,
};

FieldSet.defaultProps = {
    twoColumn: true,
    interjection: null,
};

export default FieldSet;
